module.exports = __webpack_public_path__ + "static/media/AppTitleLogo.c5ba106f.png";